import { HistoryEvent } from '../models/HistoryEvent';

export class GetScaleAccountProgress {
  status?: ScaleAccountProgressStatus;
  progressEvents?: HistoryEvent[];
}

export enum ScaleAccountProgressStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  SUCCEEDED = 3,
  FAILED = 4,
}